import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { of } from 'rxjs';
import { StoreService } from './store.service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class UserService {
  fullAccountState: any;
  currentUser = null;
  lastCheck = new Date().getTime();
  constructor(private api: ApiService, private store: StoreService) { }

  me() {
    if (this.currentUser) {
      return of(this.currentUser);
    }
    const seq = this.api.get('/admin/me');
    seq.subscribe((r: any) => {
      this.currentUser = r;
      this.store.tmp.actions = (r.profil && r.profil.actions && r.profil.actions.map(act => {
        return act.action.value;
      })) || [];
      console.log('this.store', this.store.tmp);
    });
    return seq;
  }
  login(credentials: { login: string; password: string }) {
    return this.api.post('/admin/common/login', credentials);
  }
  async logout() {
    try {
       await this.api.delete('/admin/logout').toPromise();
       this.store.merge({
        accessToken: null,
        userLogin: null
      });
    } catch (error) {
      console.error(error);
    } finally {
      window.location.reload();
    }
  }
  async checkLogin() {
    console.log('Checking login', this.lastCheck, environment.idle.timeout);
    if (new Date().getTime() - this.lastCheck > (environment.idle.value + environment.idle.timeout) * 1000) {
      console.log('Timedout, disconnection');
      // disconnection
      await this.logout();
      return;
    }
    this.lastCheck = new Date().getTime();
  }
}
